<template>
  <v-menu
    v-model="menuOpen"
    offset-y
    :close-on-content-click="false"
    content-class="task-quick-peek__menu"
    data-testid="task-quick-peek"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom content-class="tooltip-bottom" open-delay="500" :disabled="menuOpen">
        <template v-slot:activator="{ on: tipOn, attrs: tipAttrs }">
          <button
            type="button"
            class="task-detail-navs__segment-btn"
            v-bind="{ ...attrs, ...tipAttrs }"
            v-on="{ ...on, ...tipOn }"
            aria-label="Task quick peek"
            data-testid="task-detail-navs__peek-btn"
          >
      <span class="task-detail-navs__peek-dots" data-testid="task-detail-navs__peek-dots">•••</span>
          </button>
        </template>
        <span>Task Quick Peek</span>
      </v-tooltip>
    </template>

    <v-card class="task-quick-peek__card" flat data-testid="task-quick-peek__card">
      <div class="task-quick-peek__header" data-testid="task-quick-peek__header">
        <div class="task-quick-peek__header-left">
          <span class="task-quick-peek__title">Tasks</span>
          <span class="task-quick-peek__count-badge" data-testid="task-quick-peek__count">
            {{ totalTaskCount }}
          </span>
        </div>
        <span class="task-quick-peek__page-label" data-testid="task-quick-peek__page-label">
          Page {{ page }} of {{ totalPages }}
        </span>
      </div>

      <div class="task-quick-peek__list" data-testid="task-quick-peek__list">
        <TaskCardDetail
          v-for="peekTask in tasks"
          :key="peekTask._id"
          :task="peekTask"
          :selected="peekTask._id === currentTaskId"
          navigation-mode="emit"
          peek-mode
          data-testid="task-quick-peek__card-item"
          @select-task="onSelectTask"
        />
        <p
          v-if="!tasks.length"
          class="task-quick-peek__empty"
          data-testid="task-quick-peek__empty"
        >
          No tasks available
        </p>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import TaskCardDetail from '@/modules/financialclose/components/TaskCardDetail/TaskCardDetail.vue';
import './TaskQuickPeek.scss';

export default {
  name: 'TaskQuickPeek',

  components: {
    TaskCardDetail,
  },

  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
    currentTaskId: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    totalTaskCount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      menuOpen: false,
    };
  },

  methods: {
    onSelectTask(task) {
      this.menuOpen = false;
      this.$emit('select-task', task);
    },
  },
};
</script>
